import customSelect from 'custom-select';

class SelectModule {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.bindEvents();
        this.createSelect();
    }

    bindUI() {
        this.ui = {};
        this.ui.customSelect = document.querySelectorAll('.js-custom-select')
    }

    bindEvents() {
    }

    createSelect() {
        [].forEach.call(this.ui.customSelect, (item, index) => {
            customSelect(item);
        });
    }
}



export default SelectModule;
